import { EToasterStatus, showToast } from "./showToast";

export const validateLottieFile = async (file: File): Promise<boolean> => {
  if (!file.name.toLowerCase().endsWith('.json')) {
    return true; 
  }

  try {
    const text = await file.text();
    const data = JSON.parse(text);
    
    if (data.v && data.fr && data.assets) {
      return true;
    } else {
      showToast({
        message: 'Invalid Lottie animation format',
        status: EToasterStatus.ERROR,
        description: 'File must contain required properties (v, fr, assets)'
      });
      return false;
    }
  } catch (error) {
    showToast({
      message: 'Failed to process file',
      status: EToasterStatus.ERROR,
      description: error instanceof Error ? error.message : 'Unknown error'
    });
    return false;
  }
}; 